<template>
  <div class="flex flex-col lg:flex-row">
    <div v-if="continents.length > 0" class="bg-pine-green px-5 py-10 lg:w-80">
      <div v-for="continent in continents" :key="`continent-${continent.slug}`">
        <h2 class="text-22 text-light-peach-two leading-none tracking-2.25 uppercase mb-2.5">
          {{ continent.name }}
        </h2>
        <ul class="hidden lg:block mb-5">
          <li
            v-for="(country, index) in getCountries(continent.slug)"
            :key="`country-${index}`"
            class="text-xs text-light-peach-two leading-6 tracking-3 uppercase cursor-pointer"
            :class="{ 'text-dark-peach': currentCountry === country.slug }"
            @mouseover="currentCountry = country.slug"
            @mouseleave="currentCountry = null"
          >
            {{ country.name }}
          </li>
        </ul>
        <div class="lg:hidden w-full flex">
          <ul
            v-for="(list, index) in getChunkedCountries(continent.slug)"
            :key="`list-${index}`"
            class="w-1/2 first:pr-2.5 last:pl-2.5"
          >
            <li
              v-for="country in list"
              :key="`country-slug-${country.slug}`"
              class="text-xs text-light-peach-two leading-6 tracking-3 uppercase cursor-pointer"
              :class="{ 'text-dark-peach': currentCountry === country.slug }"
              @mouseover="currentCountry = country.slug"
              @mouseleave="currentCountry = null"
            >
              {{ country.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="w-full p-5 lg:px-15 lg:py-28 flex flex-col justify-center">
      <div class="relative">
        <img src="svg/map-v2.svg" class="w-full h-auto" alt="" />
        <template v-for="continent in continents">
          <svg
            v-for="country in getCountries(continent.slug)"
            :key="`country-pin-${country.slug}`"
            href="pin"
            class="absolute w-1.5 md:w-3 lg:w-5 h-2.5 md:h-5 lg:h-7.5 text-light-peach-two cursor-pointer"
            :class="{ 'text-dark-peach z-10': currentCountry === country.slug }"
            :style="getPosition(country)"
            @mouseover="currentCountry = country.slug"
            @mouseleave="currentCountry = null"
            viewBox="0 0 20 30"
          >
            <path
              fill="#010101"
              d="M20,10c0,5.5-10,20-10,20S0,15.5,0,10S4.5,0,10,0S20,4.5,20,10z"
            />
            <circle fill="currentColor" cx="10" cy="10" r="8" />
          </svg>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get';
import _chunk from 'lodash/chunk';

export default {
  props: {
    continents: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      currentCountry: null,
    };
  },

  methods: {
    getPosition(country) {
      return `top: ${country.y_coord}%; left: ${country.x_coord}%`;
    },

    getCountries(continent_slug) {
      let continent = this.continents.find((continent) => {
        return continent.slug === continent_slug;
      });

      return _get(continent, 'countries', []);
    },

    getChunkedCountries(continent_slug) {
      const countries = this.getCountries(continent_slug);
      const half = Math.ceil(countries.length / 2);
      return _chunk(countries, half);
    },
  },
};
</script>
